/**
 * Bàn thờ (Thanh Tịnh Pháp — Bàn thờ) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const AltarItemsPage = lazy(() =>
  import("@/features/altar-management").then((mod) => ({ default: mod.AltarItemsPage })),
);
const ValidationLogsPage = lazy(() =>
  import("@/features/altar-management").then((mod) => ({ default: mod.ValidationLogsPage })),
);
const AltarProceduresPage = lazy(() =>
  import("@/features/altar-management").then((mod) => ({ default: mod.AltarProceduresPage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const altarItemsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/ban-tho/vat-pham",
  component: withSuspense(AltarItemsPage),
});
const validationLogsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/ban-tho/nhat-ky",
  component: withSuspense(ValidationLogsPage),
});
const altarProceduresRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/ban-tho/quy-trinh",
  component: withSuspense(AltarProceduresPage),
});

export const banThoRoutes = [
  altarItemsRoute,
  validationLogsRoute,
  altarProceduresRoute,
];
